export default "__VITE_ASSET__BbN_G4sj__"